// List of all weather stations
import Leaflet from "leaflet";

//#region temperature icon maker and corresponding color function
export function tempMarker(temp: string): Leaflet.DivIcon {
  let markerHtmlStyles;

  if (temp === "M") {
    markerHtmlStyles = `background-color: gray; 
                        margin: 0px; 
                        color: white;`;

    return Leaflet.divIcon({
      className: "number-icon",
      html: `<div style="${markerHtmlStyles}">${temp}</div>`,
      iconSize: setTempIconSize(temp),
    });
  }

  var tempFloat: number = parseFloat(temp);
  markerHtmlStyles = `background-color: ${setColorOfTempBlock(tempFloat)}; 
                        margin: 0px; 
                        color:${setColorOfTempText(tempFloat)};`;

  return Leaflet.divIcon({
    className: "number-icon",
    html: `<div style="${markerHtmlStyles}">${temp}</div>`,
    iconSize: setTempIconSize(temp),
  });
}

function setColorOfTempBlock(temp: number): string {
  switch (true) {
    case temp >= 35.0:
      return "violet";
    case temp >= 33.0:
      return "red";
    case temp >= 28.0:
      return "#ff7800";
    case temp >= 17.0:
      return "orange";
    case temp >= 14.0:
      return "#41dc8e";
    case temp >= 12.1:
      return "green";
    case temp >= 8.0:
      return "blue";
    case temp > 0.0:
      return "purple";
    case temp <= 0.0:
      return "#42004fff";
    default:
      return "gray";
  }
}

function setColorOfTempText(temp: number): string {
  if (temp >= 33.0 && temp <= 35.0) {
    return "white";
  } else if (temp < 14.0) {
    return "white";
  }

  return "black";
}

function setTempIconSize(tempStr: string): Leaflet.PointExpression {
  switch (true) {
    case tempStr?.length === 1:
      return [21, 25];
    case tempStr?.length === 3:
      return [25, 25];
    default:
      return [35, 25];
  }
}
//#endregion
